import { NavLink } from 'react-router-dom';
import { useMe, useShop } from '@/api/hooks';
import { platform } from '@/platform';
import { Icon, type IconName } from './Icon';

const TABS: { to: string; ic: IconName | null; t: string }[] = [
  { to: '/', ic: 'table', t: 'Стол' },
  { to: '/shop', ic: 'shop', t: 'Магазин' },
  { to: '/inventory', ic: 'inventory', t: 'Инвентарь' },
  { to: '/profile', ic: null, t: 'Профиль' },
];

export function NavBar() {
  const { data: me } = useMe();
  const { data: shop } = useShop();
  const hasEvent = shop?.banners.some((b) => b.type === 'event') ?? false;
  return (
    <nav className="nav">
      {TABS.map((tab) => (
        <NavLink key={tab.to} to={tab.to} end className={({ isActive }) => (isActive ? 'active' : '')} onClick={() => platform.haptic('light')}>
          {tab.ic ? (
            <span className="ic"><Icon name={tab.ic} size={22} /></span>
          ) : (
            <span className="avatar">{me?.avatarUrl ? <img src={me.avatarUrl} alt="" /> : (me?.displayName[0] ?? '?')}</span>
          )}
          <span>{tab.t}</span>
          {tab.to === '/inventory' && !!me?.unseenItems && <i className="badge" />}
          {tab.to === '/shop' && hasEvent && <i className="badge" />}
        </NavLink>
      ))}
    </nav>
  );
}
